import { Component, OnInit, ViewChild, Output, EventEmitter, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { UniversoAuditavelService } from 'src/app/services/universo-auditavel.service';
import { IUniversoAuditavelModel } from 'src/app/models/universo-auditavel.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FiltroUniversoAuditavel } from 'src/app/models/filtro-universo-auditavel';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { ITipoUniversoModel } from 'src/app/models/tipo-universo.model';
import { MatCheckboxChange } from "@angular/material/checkbox";
import { FiltroRiscosChavesModel } from "../../../../models/filtro-riscos-chaves.model";
import { RiscosChavesServices } from "../../../../services/riscos-chaves.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import {
  ModalUniversoAuditavelImportacaoComponent
} from "../../shared/modal-universo-auditavel-importacao/modal-universo-auditavel-importacao.component";
import {
  ModalRiscosChavesImportacaoComponent
} from "../../shared/modal-riscos-chaves-importacao/modal-riscos-chaves-importacao.component";
import {
  ModalSelecaoCriterioAvaliacaoComponent
} from "../modal-selecao-criterio-avaliacao/modal-selecao-criterio-avaliacao.component";

const sortingDataAccessor = (item, property) => {
  switch (property) {
    case 'versao': return item.versao.trim().toLowerCase();
    case 'data': return item.data.trim().toLowerCase();
    case 'situacao': return item.situacao.trim().toLowerCase();
    case 'ativo':
      return item.ativo;
    default:
      return item.versao;
  }
};

@Component({
  selector: 'app-modal-selecao-universo-auditavel',
  templateUrl: './modal-selecao-universo-auditavel.component.html',
  styleUrls: ['./modal-selecao-universo-auditavel.component.scss']
})
export class ModalSelecaoUniversoAuditavelComponent extends BaseFormComponent implements OnInit {

  public semDados = true;
  public totalItens: number;
  public selecionado: IUniversoAuditavelModel;
  public filtro =  {} as FiltroUniversoAuditavel;
  public filtroRiscosChaves =  {} as FiltroRiscosChavesModel;
  public displayedColumns: string[] = ['selecao', 'nome'];
  public dataSource = new MatTableDataSource<IUniversoAuditavelModel>([]);
  public tipoUniversoId: number;
  public pageEvent: any;
  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() nomeSelecionado = new EventEmitter<string>();

  constructor(private dialogRef: MatDialogRef<ModalSelecaoUniversoAuditavelComponent>,
    private universoAuditavelService: UniversoAuditavelService,
    private risosChavesService: RiscosChavesServices,
    router: Router,
    localeService: BsLocaleService,
    public toastr: ToastrService,
    public matDialog: MatDialog,
    route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    this.filtro.unidadeGestoraId =  this.data.unidadeGestoraId;
    this.buscar();
  }

  public buscar() {
    this.universoAuditavelService.obterAtivos(this.filtro).then((res)=>{
      this.totalItens = res.dados.totalItens;
      // @ts-ignore
      this.dataSource = new MatTableDataSource<IUniversoAuditavelModel>(res.dados.resultado);
      this.paginator = this.tableOnePaginator;
      this.dataSource.sort = this.sort;
      this.dataSource.sortingDataAccessor = sortingDataAccessor;
      this.dataSource._updateChangeSubscription();
      this.semDados = this.dataSource.filteredData.length === 0;

    }).catch((err)=> {
      this.exibirMensagemErro(err.mensagem);
    });
  }

  public async concluir() {
    if(this.data.source === 'novo-risco-chaves-universo'){
      this.dialogRef.close(this.selecionado);
    }else{
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component-riscos-chaves';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        source: 'modal-importar-risco-chaves-criterio-avaliacao',
        unidadeGestoraId: this.data.unidadeGestoraId,
        tipoUniversoId: this.selecionado.id,

      };
      const modal = this.matDialog.open(ModalSelecaoCriterioAvaliacaoComponent , dialogConfig );
      modal.afterClosed().subscribe((data) => {

      });
      // this.router.navigate(['/importar-arquivo-riscos-chaves/novo'], { queryParams: { unidadeGestoraId: this.filtroRiscosChaves.unidadeGestoraId, tipoUniversoId: this.tipoUniversoId } });
      this.dialogRef.close(this.selecionado);
    }



  }
  public cancelar() {
    this.dialogRef.close(null);
  }

  public filtrar(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.semDados = this.dataSource.filteredData.length === 0;
  }

  onCheckboxChange(event: MatCheckboxChange, element: any){
    console.log(element);
    if (event.checked){
      this.selecionado = !this.selecionado || this.selecionado.id !== element.id ? element : null;
      this.nomeSelecionado = element.nomeTipoUniversoAuditavel;
      this.tipoUniversoId =  element.id;
    }
  }
  public selecionar(item: ITipoUniversoModel) {
    this.selecionado = !this.selecionado || this.selecionado.id !== item.id ? item : null;
    this.tipoUniversoId = item.id;
  }
  pageChanged(e) {
    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;
    this.buscar();
  }
}
